import styled from 'styled-components'
import { placeholder } from 'polished'

export default styled.div`
  width: 100vw;

  .empty-message {
    margin-top: auto;
    margin-left: auto;
    margin-right: auto;
    font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
    font-size: 18px;
    text-align: center;
  }

  .shop-now-btn-container {
    padding-top: 26px;
  }

  .shop-now-btn {
    display: block;
    margin: auto;
    width: 113px;
    height: 42px;
    background-color: #ffffff;
    border: solid 1px #d7d7d7;
    font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
    font-size: 12px;
  }

  .items-list {
    padding-bottom: 150px;
    margin-top: 4px;
    width: 100vw;
    overflow-y: auto;
    height: ${document.body.clientHeight - 52}px;
  }

  .bag-charge_message {
    margin: 31px auto 35px auto;
    max-width: 91.8vw;
    height: 24px;
    font-family: 'ABChanel PB Regular L', Arial, sans-serif;
    font-size: 10px;
    line-height: 1.2;
    letter-spacing: -0.025em;
    text-align: left;
    color: #000000;
  }

  .cart-footer-container {
    background-color: #ffffff;
    position: fixed;
    width: 100vw;
    height: 102px;
    border-top: 2px solid #000000;
    bottom: env(safe-area-inset-bottom);
    bottom: 0;
  }

  .subtotal-container {
    height: 32px;
    padding: 8px 10px;
    border-bottom: 1px solid #c7c7cc;
  }

  .btn-container {
    margin: 10px;
    height: 50px;

    .place-order-btn {
      width: 100%;
      height: 50px;
      color: #ffffff;
      border-radius: 0 !important;
      border: none;
      background-color: #000000 !important;
      font-family: 'ABChanel PB Regular S', Arial, sans-serif;
      font-size: 12px !important;

      &:disabled {
        opacity: 0.5;
      }

      html[lang=tw] & {
        font-size: 14px !important;
      }
    }
  }

  .item-count {
    float: left;
    margin-top: -0.4em;

    .label {
      font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
      font-size: 12px;
      font-weight: normal;
      html[lang=tw] & {
        font-size: 14px;
      }
    }
    .count {
      font-family: 'ABChanel PB Regular S', Arial, sans-serif;
      font-size: 10px;
      html[lang=tw] & {
        font-size: 12px;
      }
    }
  }

  .total-price {
    float: right;
    font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
    font-size: 12px;
    font-weight: normal;
    margin-top: -0.1em;
  }

  .staff-code-container {
    width: 91.8vw;
    height: 62px;
    margin: auto;
    margin-bottom: 68px;
  }

  .staff-code-label {
    opacity: 0.3;
    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    font-size: 10px;
    letter-spacing: -0.3px;
    text-align: left;
    color: #000000;
    margin-bottom: 7px;
  }

  .staff-code-input {
    width: 100%;
    height: 40px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    background-color: #ffffff;
    padding: 12px 10px;
    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    font-size: 12px;
    letter-spacing: -0.3px;
    text-align: left;
    ${placeholder({
      color: '#7f7f7f'
    })}
  }
`



// WEBPACK FOOTER //
// ./src/styles/Cart.js